import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "w-full" };
const _hoisted_2 = ["disabled", "placeholder", "readonly", "type", "value"];
const _hoisted_3 = ["disabled"];
const _hoisted_4 = {
    key: 0,
    class: "c-inp-error-message text-body-6 mt-4"
};
import clsx from 'clsx';
import { tv } from 'tailwind-variants';
export default /*@__PURE__*/ _defineComponent({
    __name: 'BoxInputWithButton',
    props: {
        type: { default: 'text' },
        size: { default: 'large' },
        placeholder: { default: undefined },
        modelValue: { default: '' },
        errorMessage: { default: undefined },
        isDisabled: { type: Boolean, default: false },
        isReadOnly: { type: Boolean, default: false },
        isButtonDisabled: { type: Boolean, default: false },
        buttonText: { default: 'Button' }
    },
    emits: ["update:modelValue", "click"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const input = tv({
            base: clsx('text-body-5 w-full text-gray-900 placeholder:text-gray-400 read-only:text-gray-400 read-only:text-gray-900 focus:outline-none disabled:text-gray-400', 'text-body-5', 'desktop:text-body-4'),
            variants: {
                size: {
                    small: 'rounded-tl-6 rounded-bl-6 py-8',
                    large: clsx('rounded-tl-8 rounded-bl-8 py-9', 'desktop:py-10'),
                },
            },
        });
        const inputButton = tv({
            base: clsx('rounded-tr-8 rounded-br-8 hover:bg-gray-850 bg-gray-900 px-20 py-9 text-white disabled:bg-gray-200 disabled:text-gray-400', '', 'desktop:py-12'),
        });
        const handleInput = (event) => {
            const target = event.target;
            emit('update:modelValue', target.value);
        };
        const handleClick = () => {
            emit('click');
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: _normalizeClass([
                        props.errorMessage ? 'c-inp-error' : '',
                        'group flex w-full items-center justify-between',
                    ])
                }, [
                    _createElementVNode("input", {
                        class: _normalizeClass([
                            _unref(input)({
                                size: __props.size,
                            }),
                            'border-gray-250 disabled:border-gray-250 peer border border-r-0 bg-white pl-16 transition duration-200 ease-in-out read-only:bg-gray-100 hover:border-gray-700 focus:border-gray-700 disabled:bg-gray-100 group-[.c-inp-error]:border-red-700',
                        ]),
                        disabled: props.isDisabled,
                        placeholder: props.placeholder,
                        readonly: props.isReadOnly,
                        type: __props.type,
                        value: props.modelValue,
                        onInput: handleInput
                    }, null, 42, _hoisted_2),
                    _createElementVNode("button", {
                        class: _normalizeClass(_unref(inputButton)()),
                        disabled: props.isButtonDisabled,
                        type: "button",
                        onClick: handleClick
                    }, _toDisplayString(props.buttonText), 11, _hoisted_3)
                ], 2),
                (props.errorMessage)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(props.errorMessage), 1))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
